import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';
import { Simuladores } from '../../../models/Simuladores';
import { SimuladoresDetalle } from '../../../models/SimuladoresDetalle';
import { SimuladorService } from '../../../services/operaciones/simulador/simulador.service';

@Component({
  selector: 'app-detalle-simulador',
  templateUrl: './detalle-simulador.component.html',
  styleUrls: ['./detalle-simulador.component.scss']
})
export class DetalleSimuladorComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Simulador=environment.LABEL_SIMULADOR;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  //! Event Emitter
  @Output() cerrarSimuladorDetalle: EventEmitter<boolean> = new EventEmitter();
  //! Input
  @Input() idSimulador: number = 0;
  //! Variables de obtencion de Datos
  Simuladores : Simuladores = new Simuladores();
  SimuladoresDetalle : SimuladoresDetalle[] = [];
  loading:boolean;                                
  //! Ranking
  Ranking : any ;
  SimuladoresTotales: any = {
    VNPP : 0,
    Adelanto :  0,
    Interes :  0,
    Comision :  0,
    IGV_TOTAL :  0,
    Desembolso :  0,
    Remanente :  0,
  };
  constructor(private simuladorService:SimuladorService) { }
  
  ngOnInit() {
    this.ObtenerSimuladorID();
    this.ObtenerSimuladorDetalle();
  }

  ObtenerRanking(ruc_adq){
    this.Ranking =  this.simuladorService.obtenerRanking(ruc_adq); 
  }

  MetcerrarSimuladorDetalle(){
    this.cerrarSimuladorDetalle.emit();
  }

  ObtenerSimuladorID(){
    this.simuladorService.obtenerSimulador(this.idSimulador).subscribe(res =>{
      this.Simuladores = res as Simuladores;
      this.Simuladores.Num_Doc_IdentificacionA = res.Num_Doc_Identificacion_Adq;
      this.ObtenerRanking(this.Simuladores.Num_Doc_IdentificacionA);
    });
  }

  ObtenerSimuladorDetalle(){
    this.simuladorService.obtenerSimuladorDetalle(this.idSimulador).subscribe(res =>{
      this.SimuladoresDetalle = res as SimuladoresDetalle[];
      this.CalcularTotales()
      this.loading = false;
    });
  }

  CalcularTotales(){
    this.loading = true;
      let TotalVNPP :number = 0;
      let TotalAdelanto : number = 0;
      let TotalIGV : number = 0;
      let TotalInteres : number = 0;
      let TotalComision : number = 0;
      let TotalDesembolso : number = 0;
      let TotalRemanente : number = 0;
      for (let item of this.SimuladoresDetalle) {
        TotalVNPP += Number(item.VNPP) ; 
        TotalAdelanto += Number(item.Adelanto);
        TotalInteres += Number(item.Interes);
        TotalComision += Number(item.Comision);
        TotalIGV += Number(item.IGV);
        TotalDesembolso += Number(item.Desembolso);
        TotalRemanente += Number(item.Remanente);
      }
      this.SimuladoresTotales.VNPP = TotalVNPP;
      this.SimuladoresTotales.Adelanto = TotalAdelanto;
      this.SimuladoresTotales.Interes = TotalInteres;
      this.SimuladoresTotales.Comision = TotalComision;
      this.SimuladoresTotales.IGV_TOTAL = TotalIGV;
      this.SimuladoresTotales.Desembolso = TotalDesembolso;
      this.SimuladoresTotales.Remanente = TotalRemanente;
      this.loading = false;
  }
}

